import { Box } from '@mui/material';
import { WALLET_PHRASES } from '@/consts/phrases/walletPhrases';
import { usePhrase } from '@/hooks';

export const NonTaxable = () => {
    const { t } = usePhrase();
    return (
        <Box component="span" className="non-taxable-badge">
            {t(WALLET_PHRASES.NON_TAXABLE)}
        </Box>
    );
};
